import { useQuery } from "@tanstack/react-query";
import commentsAPI from "../../api/comments/api";

export function getQueryKey(id: string | number, category: string) {
  return ["comments", category, id];
}

export function useGetCommentsByContentId(
  category: string,
  id: string | number,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: getQueryKey(id, category),
    queryFn: () => commentsAPI.getContentComments(category, id),
    enabled: !!id && options?.enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
